<template>
	<div class="self-start">
		<div id="back">
			<router-link to="/work">
				<i class="times"></i>
			</router-link>
		</div>

		<div class="container">
			<slot></slot>
		</div>
	</div>
</template>

<script>

export default {

}

</script>